import { IDropdownSelectOption } from 'components/DropdownSearchSelect/DropdownSearchSelect';
import { ICampaignFormData, IHTMLPopUpTemplateFormData } from './types';
import { TAlertType } from 'reduxState/store/campaigns/types';

export const insertionTypeOptions: IDropdownSelectOption[] = [
  { label: 'Before', value: 'BEFORE' },
  { label: 'After', value: 'AFTER' },
  { label: 'Prepend', value: 'PREPEND' },
  { label: 'Append', value: 'APPEND' },
];

export const frequencyTypeOptions: IDropdownSelectOption[] = [
  { label: 'Dismissal', value: 'DISMISSAL' },
  { label: 'View Count', value: 'VIEW_COUNT' },
];

export const displayTypeOptions: IDropdownSelectOption[] = [
  { label: 'Pop Up', value: 'POP_UP' },
  { label: 'Inline', value: 'INLINE' },
  { label: 'HTML Pop Up', value: 'HTML_POP_UP' },
  { label: 'HTML Pop Up Template', value: 'HTML_POP_UP_TEMPLATE' },
  { label: 'Alert HTML', value: 'ALERT_HTML' },
];

export const alertTypeOptions: { label: string; value: TAlertType }[] = [
  { label: 'Unactivated EMA', value: 'ALERT_UNACTIVATED_EMA' },
  { label: 'Activated EMA', value: 'ALERT_ACTIVATED_EMA' },
  { label: 'NMV', value: 'ALERT_NMV' },
  { label: 'Purchase Detection', value: 'ALERT_PURCHASE_DETECTION' },
  { label: 'Couponator Start', value: 'ALERT_COUPONATOR_START' },
  { label: 'Couponator End', value: 'ALERT_COUPONATOR_END' },
];

export const defaultCampaignFormData: ICampaignFormData = {
  displayType: null,
  title: '',
  merchantId: '',
  merchantDisplayName: '',
  networkMerchantId: '',
  startDate: null,
  endDate: null,
  insertionOrderId: '',
  insertionOrderValue: '',
  urlPatterns: [],
  urlPatterns2: [],
  searchPhrases: [],
  serpTagline: '',
  destinationURL: '',
  frequencyType: null,
  minutes: null,
  limit: null,
  cooldown: null,
  headline: '',
  mainText: '',
  ctaColor: '',
  ctaLabel: '',
  target: '',
  insertion: null,
  style: '',
  content: '',
  alertTypes: [],
  googleSheetID: '',
};

export const defaultHTMLPopUpTemplateFormData: IHTMLPopUpTemplateFormData = {
  containerWidth: '300', // pixels
  containerBackgroundImageSrc: `https://storage.googleapis.com/dev-wl-image-49ff26cf/ccb7a680d4e447b7506f77dab10050b7c38ffee6`,
  containerBackgroundImagePosition: {
    // pixels
    x: '0',
    y: '-18',
  },
  containerBackgroundColorOpacity: '75',
  topContainerMargin: {
    // pixels
    top: '0',
    right: '0',
    bottom: '4',
    left: '0',
  },
  merchantLogoWidth: '30',
  merchantLogoMargin: {
    // pixels
    top: '14',
    right: '0',
    bottom: '0',
    left: '4',
  },
  textColor: '#fff',
  textFontFamily: 'sans-serif',
  textTitleMargin: {
    // pixels
    top: '0',
    right: '0',
    bottom: '0',
    left: '8',
  },
  textMargin: {
    top: '2',
    right: '0',
    bottom: '8',
    left: '8',
  },
  buttonWidth: '100', // percentages
  buttonPadding: {
    // pixels
    top: '8',
    right: '0',
    bottom: '8',
    left: '0',
  },
  buttonImageWidth: '18', // pixels
  buttonImageMargin: {
    // pixels
    top: '0',
    right: '2',
    bottom: '0',
    left: '0',
  },
  buttonSpanCalloutColor: '#74c947',
  headerText: 'Invest in your future. Earn at Groupon.',
  subText: 'Stack up the savings and a bonus investment at Groupon.',
  merchantLogoSrc: 'https://storage.googleapis.com/dev-wl-image-49ff26cf/26aea672a752e435152b2036b9ccffba44fecd87',
  merchantLogoAlt: 'groupon-icon',
  buttonPrefixText: 'Get up to',
  buttonTextCallout: '1.5%',
  buttonSuffixText: ' invested',
  buttonImageSrc: 'https://storage.googleapis.com/dev-wl-image-49ff26cf/ab52e3d25fb3b91106ce808f41391bf949ca5c51',
  buttonImageAlt: 'acorn',
  destinationURL: '',
};
